import { Mail, Instagram, Linkedin } from "lucide-react";
import { Link } from "react-router-dom";

export const Footer = () => {

  return (
    <footer className="bg-[#00123A] text-white py-12">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <h3 className="text-xl font-bold mb-4 text-white">Enfants de la République</h3>
            <p className="text-sm text-white opacity-80">
              Transmettre, renforcer, protéger la citoyenneté française.
            </p>
          </div>
          
          <div>
            <h3 className="text-xl font-bold mb-4 text-white">Contact</h3>
            <div className="space-y-2 text-white">
              <div className="flex items-center space-x-2">
              </div>
              <div className="flex items-center space-x-2">
                <Mail size={18} />
                <span className="text-sm">contact@ledlr.org</span>
              </div>
            </div>
          </div>
          
          <div>
            <h3 className="text-xl font-bold mb-4 text-white">Follow</h3>
            <div className="flex space-x-4">
              <a 
                href="https://www.instagram.com/enfantsdelarepublique?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-white hover:text-[#FFFF4D] transition-colors"
              >
                <Instagram size={24} />
              </a>
              <a href="https://www.linkedin.com/company/enfants-de-la-r%C3%A9publique/" target="_blank" rel="noopener noreferrer" className="text-white hover:text-[#FFFF4D] transition-colors">
                <Linkedin size={24} />
              </a>
            </div>
          </div>
        </div>
        
        <div className="mt-8 pt-8 border-t border-white/10 text-center text-sm text-white">
          <p>
            © {new Date().getFullYear()} Enfants de la République. Tous droits réservés.
            <span className="mx-2">|</span>
            <Link to="/politique-confidentialite" className="hover:underline">
              Politique de confidentialité
            </Link>
            <span className="mx-2">|</span>
            <Link to="/mentions-legales" className="hover:underline">
              Mentions légales
            </Link>
            <span className="mx-2">|</span>
            <a 
              href="https://jqswmyqzmjdstetjqzvv.supabase.co/storage/v1/object/public/statuts/Association%20EDLR-statuts.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:underline"
            >
              Statuts de l'association
            </a>
            <span className="mx-2">|</span>
            <a 
              href="https://jqswmyqzmjdstetjqzvv.supabase.co/storage/v1/object/public/reglement/Association%20EDLR-reglement.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:underline"
            >
              Règlement intérieur
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};
